
import React, { Component } from 'react';
// import ReactResizeDetector from 'react-resize-detector';
import StripTags from '../../helpers/StripTags';

import '../../styles/Header.scss';
//
//

class Header extends React.Component<any> {


  render() {

    var avatar, headingLeft;
    var left = this.props.layout.leftPadding + 12;


    if (this.props.config.settings.avatarURL) {
      avatar = <div
        className="sce-headerAvatar"
        style={{
          bottom: "8px",
          left: left + "px",
          width: (this.props.layout.headerHeight - 16) + "px",
          height: (this.props.layout.headerHeight - 16) + "px"
        }}>
        <img src={this.props.config.settings.avatarURL} alt={"Chatbot Avatar"} />
      </div>
      left += this.props.layout.headerHeight - 6; // Add the avatar width.
    }



    const headerStyle = { background: "#FFFFFF", height: this.props.layout.headerHeight + "px", width: (this.props.layout.width + this.props.layout.paddingLeft + this.props.layout.rightPadding) + "px" }
    const titleStyle = { left: left + "px", right: (this.props.layout.headerHeight + this.props.layout.rightPadding) + "px", lineHeight: this.props.layout.headerHeight + "px" }
    const arrowStyle = (this.props.config.headerColor) ? { borderTopColor: this.props.config.headerColor, transform: this.props.arrowTransform } : { transform: this.props.arrowTransform }


    const headerText = (this.props.customHeaderText) ? this.props.customHeaderText : this.props.config.settings.headerText;


    return <div
      className="sce-Header swivl-header"
      onClick={this.props.toggleOpen}
      style={headerStyle}>
      {avatar}
      <div
        className="sce-heading"
        style={titleStyle}
        dangerouslySetInnerHTML={{ __html: StripTags(headerText) }}
      />
      <div
        className="sce-arrowWrapper swivl-header"
        style={{ height: this.props.layout.headerHeight + "px", width: this.props.layout.headerHeight + "px", right: this.props.layout.rightPadding + "px" }}>
        <div className="sce-arrow" style={arrowStyle}></div>
      </div>
    </div>;
  }

}

export default Header;
